import React from 'react';
import { Kid, Quest } from '../types';

interface ManageViewProps {
  kid: Kid | undefined;
  quests: Quest[];
  onOpenAddQuest: () => void;
  onDeleteQuest: (questId: string) => void;
  onOpenAdultZone: () => void;
}

export const ManageView: React.FC<ManageViewProps> = ({
  kid,
  quests,
  onOpenAddQuest,
  onDeleteQuest,
  onOpenAdultZone,
}) => {
  const kidName = kid?.name || 'Kid';

  return (
    <div className="manage-view">
      <div className="manage-header">
        <div>
          <h3 className="section-title" style={{ margin: 0 }}>
            {kidName}'s Quests
          </h3>
          <p style={{ fontSize: '13px', color: '#64748b' }}>
            Add, update, or remove daily activities.
          </p>
        </div>

        <button
          id="btn-add-quest-manage"
          className="add-quest-main-btn"
          onClick={onOpenAddQuest}
        >
          <span>+</span> Add Quest
        </button>
      </div>

      {quests.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-emoji">📝</div>
          <h4 className="empty-state-title">No quests found for {kidName}</h4>
          <p className="empty-state-subtitle">Tap "+ Add Quest" above to create one!</p>
        </div>
      ) : (
        <div className="manage-quests-list">
          {quests.map((quest) => (
            <div key={quest.id} className="manage-quest-item">
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div className="quest-icon-box" style={{ width: '44px', height: '44px', fontSize: '22px' }}>
                  <span>{quest.icon_emoji}</span>
                </div>
                <div>
                  <h4 style={{ fontSize: '16px', fontWeight: 800, color: '#1e1b4b' }}>
                    {quest.name}
                  </h4>
                  <p style={{ fontSize: '12px', color: '#64748b' }}>
                    {quest.repeat_days.join(', ')}
                    {quest.time_str ? ` · 🕒 ${quest.time_str}` : ''} · ⭐ {quest.points}
                  </p>
                </div>
              </div>

              <button
                id={`btn-delete-quest-${quest.id}`}
                className="btn-delete-quest"
                onClick={() => {
                  if (confirm(`Delete quest "${quest.name}"?`)) {
                    onDeleteQuest(quest.id);
                  }
                }}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Adult Zone Card helper */}
      <div
        style={{
          marginTop: '32px',
          padding: '20px',
          background: '#ffffff',
          borderRadius: '22px',
          border: '2px solid #ede9fe',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <h4 style={{ fontSize: '15px', fontWeight: 800, color: '#1e1b4b' }}>
            Looking for Rewards & PIN settings?
          </h4>
          <p style={{ fontSize: '13px', color: '#64748b', marginTop: '2px' }}>
            Adults can create rewards and manage family settings in the Adult Zone.
          </p>
        </div>
        <button
          className="adult-zone-btn"
          onClick={onOpenAdultZone}
          style={{ whiteSpace: 'nowrap', marginLeft: '12px' }}
        >
          🔒 Adult Zone
        </button>
      </div>
    </div>
  );
};
